// axiosAuth.js — import ONCE (side-effect import) so every axios call sends the JWT.
import axios from "axios";

// Look for the token under the keys apps commonly use. Adjust if your login saves it elsewhere.
const getToken = () => {
  const direct =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("token");
  if (direct) return direct;
  try {
    const u = JSON.parse(localStorage.getItem("user") || "{}");
    return u.token || u.accessToken || null;
  } catch {
    return null;
  }
};

// Guard so hot-reload / multiple imports don't stack interceptors.
if (!axios.__authInterceptorsInstalled) {
  axios.__authInterceptorsInstalled = true;

  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token && !config.headers?.Authorization) {
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
  });

  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response?.status === 401) {
        console.warn("401 from API:", err.config?.url, err.response?.data?.message);
        // Uncomment to force re-login on expired/invalid token:
        // localStorage.removeItem("token");
        // window.location.href = "/login";
      }
      return Promise.reject(err);
    }
  );
}

export default axios;